import { render, staticRenderFns } from "./transaction-managment.vue?vue&type=template&id=425ccffe"
import script from "./transaction-managment.vue?vue&type=script&lang=js"
export * from "./transaction-managment.vue?vue&type=script&lang=js"
import style0 from "./transaction-managment.vue?vue&type=style&index=0&id=425ccffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports